import type { ListenerMiddlewareInstance } from '@reduxjs/toolkit';

import type { RootState } from '../../structureDefinitions/cartState';

import { getThemeClassnames, type SiteTheme } from '../../../../../theme';
import persistance from '../../../persistance/persistance';
import { featureFlagsActions } from '../../slices/featureFlags/featureFlagsSlice';

export const featureFlagMiddleware = (
    middlewareInstance: ListenerMiddlewareInstance<RootState>,
) => {
    middlewareInstance.startListening({
        actionCreator: featureFlagsActions.setFeatureFlag,
        effect: async (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const { featureFlags } = listenerApi.getOriginalState();

            switch (action.payload.key) {
                case 'siteTheme': {
                    siteThemeActionEffect(
                        featureFlags.siteTheme,
                        action.payload.value as typeof featureFlags.siteTheme,
                    );
                    break;
                }

                default:
            }
        },
    });
    middlewareInstance.startListening({
        actionCreator: featureFlagsActions.setFeatureFlagNotProd,
        effect: async (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            switch (action.payload.key) {
                case 'enableFullSpaMode': {
                    spaModeActionEffect(action.payload.value as boolean);
                    break;
                }
                default:
            }
        },
    });
};

const siteThemeActionEffect = (oldValue: SiteTheme, newValue: SiteTheme) => {
    const oldThemes = getThemeClassnames(oldValue);
    const newThemes = getThemeClassnames(newValue);
    const htmlElement = document.getElementsByTagName('html')[0];
    htmlElement.classList.remove(...oldThemes);
    htmlElement.classList.add(...newThemes);
};

const spaModeActionEffect = (enabled: boolean) => {
    persistance.cookieBasedFeatureToggles.enableFullSpaMode(enabled);
    window.location.reload(); // reload so that backend can render new scripts
};
